/**
 * Uids issus du routeur pour les appels d’auth client (query / lien invitation).
 */
export type CustomerLoginRouterScope = {
	loginFolderUid: string | undefined;
	loginOfficeUid: string | undefined;
	loginCustomerUid: string | undefined;
};

/** True when the URL carries at least one invitation / deep-link disambiguation id (not email-only landing). */
export function routerHasCustomerLoginInvitationScope(scope: CustomerLoginRouterScope): boolean {
	return Boolean(
		(scope.loginFolderUid && scope.loginFolderUid.trim()) ||
			(scope.loginOfficeUid && scope.loginOfficeUid.trim()) ||
			(scope.loginCustomerUid && scope.loginCustomerUid.trim()),
	);
}
